module.exports={turnstile_modal:{message:"กำลังยืนยันรายละเอียดความปลอดภัย"}};